import axios from 'axios';
import config from '../config';
import { store } from '../store';

const BASE = '/doctor-dashboard-api';

const getHeaders = () => {
  const { authToken } = store.getState().user;
  return authToken ? { authorization: authToken } : {};
};

const get = (path) =>
  axios.get(`${config.apiBaseUrl}${BASE}${path}`, { headers: getHeaders() }).then(r => r.data);

const post = (path, data) =>
  axios.post(`${config.apiBaseUrl}${BASE}${path}`, data, { headers: getHeaders() }).then(r => r.data);

const put = (path, data) =>
  axios.put(`${config.apiBaseUrl}${BASE}${path}`, data, { headers: getHeaders() }).then(r => r.data);

const del = (path) =>
  axios.delete(`${config.apiBaseUrl}${BASE}${path}`, { headers: getHeaders() }).then(r => r.data);

export const attendanceApi = {
  status:     () => get('/attendance/status'),
  checkIn:    () => post('/attendance/check-in'),
  checkOut:   () => post('/attendance/check-out'),
  startBreak: (reason) => post('/attendance/break/start', { reason }),
  endBreak:   () => post('/attendance/break/end'),
  history:    (days = 7) => get(`/attendance/history?days=${days}`),
};

export const closuresApi = {
  my:           () => get('/closures/my'),
  all:          () => get('/admin/closures'),
  productivity: (doctorId, date) => get(`/admin/productivity?doctorId=${doctorId}&date=${date}`),
  historyReport:(doctorId, days = 7) => get(`/admin/history?doctorId=${doctorId}&days=${days}`),
};

export const messagesApi = {
  active:     () => get('/messages/active'),
  all:        () => get('/admin/messages'),
  broadcast:  (body) => post('/admin/broadcast', body),
  deactivate: (id) => del(`/admin/messages/${id}`),
};

export const adminApi = {
  doctors:         (insurer) => get(`/admin/doctors${insurer ? `?insurer=${insurer}` : ''}`),
  availability:    () => get('/admin/availability'),
  changeInsurer:   (body) => put('/admin/change-insurer', body),
  grantAccess:     (body) => put('/admin/grant-access', body),
  insurerClosures: () => get('/admin/insurer-closures'),
  misStatus:       (days = 45) => get(`/admin/mis-status?days=${days}`),
};
